import React, { useState, useEffect } from "react";
import { Box, Typography, useMediaQuery, Link } from "@mui/material";
import team1 from "../images/location1.png";
import team2 from "../images/location2.png";
import team3 from "../images/location3.png";
import team4 from "../images/location4.jpeg";
import logo1 from "../images/2-removebg-preview.png";
import logo2 from "../images/3-removebg-preview.png";
import logo3 from "../images/4-removebg-preview.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Locations = () => {
  // Media queries
  const is1023 = useMediaQuery("(max-width:1023px)");
  const is768 = useMediaQuery("(max-width:768px)");
  const is425 = useMediaQuery("(max-width:425px)");
  const is375 = useMediaQuery("(max-width:375px)");
  const is320 = useMediaQuery("(max-width:320px)");
  // const isMobile = useMediaQuery("(max-width:750px)");

  const boxes = [
    {
      id: 1,
      title: ["Malaysia (HQ)"],
      content: [
        "CENSOFT MALAYSIA SDN BHD,",
        "B-2-3 CoPlace 2,",
        "2260 Jalan Usahawan 1,",
        "63000 Cyberjaya, Malaysia.",
      ],
      email: "info@censoftech.com ",
      image: team1,
      Icon: logo1,
      mapUrl:
        "https://www.google.com/maps/place/Coplace+2/@2.9256741,101.6629164,1151m/data=!3m2!1e3!4b1!4m6!3m5!1s0x31cdb6578a59e387:0x2a10fe23b3099779!8m2!3d2.9256741!4d101.6629164!16s%2Fg%2F11g7nrv90s?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
    },
    {
      id: 2,
      title: ["Malaysia ", "(Branch Office)"],

      content: [
        "CENSOFT MALAYSIA SDN BHD,",
        "73-3-1 iDeal@The One,",
        "Jalan Mahsuri,",
        "Bayan Lepas 11950 Pulau Pinang,",
        "Malaysia.",
      ],
      email: "info@censoftech.com ",
      image: team2,
      Icon: logo2,
      mapUrl:
        "https://www.google.com/maps?ll=5.327431,100.281872&z=15&t=m&hl=en&gl=IN&mapclient=embed&q=CENSOFT+MALAYSIA+SDN+BHD+73-3-1+iDeal@The+One,+Jalan+Mahsuri,+Bayan+Lepas+11950+Pulau+Pinang,+Malaysia",
    },
    {
      id: 3,
      title: ["India"],
      content: [
        "CENSOFT TECHNOLOGIES PVT LTD,",
        "23, ELCOT IT Park,",
        "Airport Ring Road,",
        "Madurai, Tamilnadu, India.",
      ],
      email: "info@censoftech.com ",
      image: team3,
      Icon: logo3,
      mapUrl:
        "https://www.google.com/maps/place/ELCOT+IT+Park,+Madurai/@9.937648,78.167516,4541m/data=!3m1!1e3!4m6!3m5!1s0x3b00c437f113c7a3:0xf66b508cdee26cc!8m2!3d9.9376482!4d78.1675161!16s%2Fg%2F11dzddt8j8?hl=en&entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
    },
    // {
    //   id: 4,
    //   title: ["Indonesia"],
    //   content: [
    //     "PT CENSOFT INDONESIA",
    //     "Wisma 46, JI, Jendral Sudhirman Kva, Karet Tengsin,",
    //     "Jakarta, DKI Jakarta,",
    //     "Indonesia - 10220",
    //   ],
    //   email: "info@censoftech.com ",
    //   image: team4,
    //   Icon: logo3,
    //   mapUrl:
    //     "https://www.google.com/maps/place/Wisma+46/@-6.203743,106.8179204,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f41db2355327:0x5cba7ce473a98b52!8m2!3d-6.203743!4d106.8204953!16s%2Fg%2F11bzz2l9nt?entry=ttu&g_ep=EgoyMDI1MDcwOS4wIKXMDSoASAFQAw%3D%3D",
    // },
  ];

  const [selectedBox, setSelectedBox] = useState(boxes[0].id);

  // Default first box selected on mobile
  // useEffect(() => {
  //   if (isMobile) {
  //     setSelectedBox(boxes[0].id);
  //   }
  // }, [isMobile]);

  // const getBoxWidth = (isSelected) => {
  //   if (is320) return "90%";
  //   if (is375) return isSelected ? 320 : 260;
  //   if (is425) return isSelected ? 350 : 280;
  //   if (is768) return isSelected ? 400 : 300;
  //   if (is1023) return isSelected ? 500 : 350;
  //   return isSelected ? 550 : 300;
  // };

  const getImageSize = () => {
    if (is320) return 120;
    if (is375) return 140;
    if (is425) return 200;
    if (is768) return 180;
    return 250;
  };

  const getFontSize = () => {
    if (is320) return "12px";
    if (is375) return "13px";
    if (is425) return "14px";
    if (is768) return "14.5px";
    return "15px";
  };

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transition: "all 0.6s ease-in-out",
          textAlign: "center",
          mb: 6,
          mt: 8,
        }}
      >
        <Typography
          variant="h3"
          fontWeight="bold"
          sx={{ fontFamily: "Aeonik-bold", fontWeight: 800 }}
        >
          Our Locations
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection={is1023 ? "row" : "row"} // keep row layout for horizontal scroll
        gap={2}
        p={2}
        sx={{
          justifyContent: is1023 ? "flex-start" : "center",
          alignItems: "center",
          overflowX: is1023 ? "auto" : "visible", // scroll on small screens
          scrollSnapType: is1023 ? "x mandatory" : "none",
          scrollPadding: 16,
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {boxes.map((box) => {
          const isSelected = selectedBox === box.id;
          const imageSize = getImageSize();
          const fontSize = getFontSize();

          return (
            <Box
              key={box.id}
              sx={{
                position: "relative",
                width: isSelected
      ? { xs: "350px", md: "350px",lg: "500px" } // 👈 reduce at md (1024px)
      : { xs: "300px", md: "250px",lg:"300px" }, // 👈 reduce at md (1024px)
    minWidth: { xs: "300px", md: "250px" }, 
                height: 400,
                transition: "width 0.4s ease", // 👈 smooth width transition
                backgroundColor: "#29292a",
                borderRadius: 2,
                boxShadow: 3,
                overflow: "hidden",
                padding: 2,
                cursor: "pointer",
                color: "white",
                display: "flex",
                flexDirection: "column",
                justifyContent: isSelected ? "flex-start" : "flex-end",
                scrollSnapAlign: is1023 ? "start" : "none",
                flexShrink: 0,
                mx: 1,
              }}
              onMouseEnter={() => {
                setSelectedBox(box.id);
              }}
            >
              {/* Image */}
              <Box
                component="img"
                src={box.image}
                alt=""
                sx={{
                  position: "absolute",
                  top: -75,
                  right: -26,
                  width: imageSize,
                  height: imageSize,
                  borderRadius: "45%",
                  boxShadow: 2,
                  backgroundColor: "#fff",
                  objectFit: "cover",
                  userSelect: "none",
                  pointerEvents: "none",
                  zIndex: 1,
                }}
              />

              {/* Text Container */}
              <Box
                sx={{
                  position: "relative",
                  zIndex: 2,
                  mt: isSelected ? 5 : 0,
                  pl: isSelected ? 2 : 0,
                  transition: "all 0.1s ease",
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  flexDirection={is425 ? "column" : "row"}
                  sx={{
                    transition: "all 0.1s ease",
                    ml: isSelected || is425 ? 0 : 8,
                    mb: 1,
                    textAlign: is425 ? "center" : "left",
                  }}
                >
                  <Box
                    component="img"
                    src={box.Icon}
                    alt="icon"
                    sx={{
                      width: 30,
                      height: 30,
                      objectFit: "contain",
                      mr: is425 ? 0 : 1,
                      mb: is425 ? 1 : 0,
                    }}
                  />
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      color: "white",
                      fontSize: is320 ? "16px" : is375 ? "18px" : "20px",
                      whiteSpace: "pre-line",
                      lineHeight: 1.2,
                    }}
                  >
                    {box?.title?.map((part, index, arr) => (
                      <React.Fragment key={index}>
                        {part.trim()}
                        {index !== arr.length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </Typography>
                </Box>

                {/* Show description only if selected (or always for mobile) */}
                {(isSelected || is1023) && (
                  <>
                    <Box
                      data-aos="fade-right"
                      sx={{
                        display: "flex",
                        width: "40%",
                        height: 2,
                        backgroundColor: "red",
                        mt: 8,
                        mb: 1,
                        borderRadius: 1,
                        alignItems: "left",
                      }}
                    />

                    <Typography
                      data-aos="fade-up"
                      fontSize={fontSize}
                      sx={{
                        mt: 3,
                        opacity: 1,
                        fontWeight: "bold",
                        textAlign: is425 ? "center" : "left",
                      }}
                    >
                      {box?.content?.map((part, index, arr) => (
                        <React.Fragment key={index}>
                          {part.trim()}
                          {index !== arr.length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </Typography>
                    <Typography
                      data-aos="fade-up"
                      fontSize={fontSize}
                      sx={{
                        opacity: 1,
                        fontWeight: "bold",
                        textAlign: is425 ? "center" : "left",
                      }}
                    >
                      Email:{" "}
                      {box?.email && (
                        <Link
                          component="button"
                          variant="body2"
                          onClick={() => {
                            window.open(`mailto:${box.email}`, "_blank"); // or just `window.location.href = ...`
                          }}
                          sx={{
                            color: "white",
                            textDecoration: "none",
                            textDecoration: "underline",
                            "&:hover": {
                              color: "primary.dark",
                            },
                            fontFamily: "inherit",
                            fontSize: "inherit",
                            fontWeight: "inherit",
                            lineHeight: "inherit",
                          }}
                        >
                          {box.email}
                        </Link>
                      )}
                    </Typography>

                    {/* Add Google Maps iframe and view link */}
                    <Box
                      data-aos="fade-up"
                      sx={{
                        mt: `${
                          box?.title[1] === "(Branch Office)" ? "5px" : "57px"
                        }`,
                        textAlign: "center",
                      }}
                    >
                      <Box
                        component="a"
                        href={box.mapUrl.replace("embed", "maps/place")}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          position: "relative",
                          overflow: "hidden",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "rgba(255, 192, 203, 1)",
                          color: "black",
                          px: 4,
                          py: 1.5,
                          borderRadius: 2,
                          fontWeight: "bold",
                          fontSize: "1rem",
                          textDecoration: "none",
                          textTransform: "none",
                          transition: "color 0.3s ease",
                          zIndex: 1,
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(173, 216, 230, 1)",
                            transform: "translateY(100%)",
                            transition: "transform 0.4s ease",
                            zIndex: -1,
                          },
                          "&:hover::before": {
                            transform: "translateY(0%)",
                          },
                          "&:hover": {
                            color: "black",
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src="https://www.google.com/images/branding/product/1x/maps_32dp.png"
                          alt="Google Maps"
                          sx={{
                            height: 20,
                            width: 20,
                            mr: 1.5,
                            filter: "brightness(0) invert(1)",
                            color: "black",
                          }}
                        />
                        View Location on Google Maps
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Locations;
